"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkBrowser = checkBrowser;
var _constants = require("@studio/constants");
function checkBrowser() {
  var userAgent = navigator.userAgent;
  var isChromium = userAgent.includes('Chrome') || userAgent.includes('Chromium') || userAgent.includes('Edg');
  if (!isChromium) {
    console.warn('ReadinessCheck - Unsupported browser:', userAgent);
  }
  return {
    status: isChromium ? _constants.PASSED : _constants.FAILED
  };
}